export const isErrorWithCode = (error: unknown): error is Error & { code: string } => {
  return error instanceof Error && "code" in error;
};
